import { cn } from "~/utils/fontsConfig";
import Image from "next/image";

import { Avatar, AvatarFallback } from "../shadcn/Avatar";
import { UserAvatar } from "../v4/shadcn/UserAvatar";

const UserImage = ({
    user,
    iconSize,
    className,
}: {
    user: {
        id: string;
        name: string | null;
        image?: string | null;
        organizationImage?: string | null;
        organizationName?: string | null;
        useOrganizationIdentity?: boolean | null;
    };
    iconSize: number;
    className?: string;
}) => {
    if (!user) return null;
    let image = user.image;

    if (
        !!user.useOrganizationIdentity &&
        user.organizationImage &&
        !!user.organizationName
    ) {
        image = user.organizationImage;
    }

    return (
        <>
            {image ? (
                <Image
                    className={cn("rounded-full object-cover", className)}
                    style={{
                        height: `${iconSize}px`,
                    }}
                    src={image}
                    alt={user.name || "user-pfp"}
                    width={iconSize}
                    height={iconSize}
                />
            ) : (
                <Avatar
                    className={`h-[${iconSize}px]`}
                    style={{
                        width: `${iconSize}px`,
                    }}
                >
                    <AvatarFallback
                        className="bg-tertiary"
                        style={{ width: iconSize, height: iconSize }}
                    >
                        <UserAvatar user={user} className="h-full w-full" />
                    </AvatarFallback>
                </Avatar>
            )}
        </>
    );
};

export default UserImage;
